module.exports = __webpack_public_path__ + "static/media/Neo4j-logo-color.0dbde25b.svg";